<template>
  <div class="gf_price-compare">
    <div class="gf_price-compare__sticky" v-if="isFixedNav">
      <div class="gf_price-compare__section gf_pricing__container" :class="{'gf_price-compare__section--trial': isTableCol4}">
        <div class="gf_price-compare__box__plan gf_price-compare__box__plan__sticky">
          <div class="gf_pricing__switch">
            <div class="gf_pricing__switch--month" :class="{'mode-disabled': yearlyMode}">{{ $t('downgrade.confirm.choosedPlan.billingInterval.monthly') }}</div>
            <div class="gf_pricing__switch--toggle">
              <Switcher
                v-model="yearlyMode"
                :padding="'p-0 m-0'"
                :classToggler="'p-0 m-0'"
                @input="setYearlyMode(yearlyMode)"
              >
              </Switcher>
            </div>
            <div class="gf_pricing__switch--year" :class="{'mode-disabled': !yearlyMode}">{{ $t('downgrade.confirm.choosedPlan.billingInterval.yearly') }}</div>
            <div class="gf_pricing__switch--sale">({{ $t('generals.save') }} 20%)</div>
          </div>
          <Dropdown :hasSpan="true" :hideArrow="true" :callbackOutSide="onCloseDiscountCode" ref="discountCode" lclass="-left-68 rounded-12" dropdownClass="width-312">
            <template v-slot:span>
              <div class="gf_pricing__discount" v-if="!isDevelopmentStore">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.7808 8.28082C13.0737 7.98793 13.0737 7.51305 12.7808 7.22016C12.4879 6.92727 12.0131 6.92727 11.7202 7.22016L7.22016 11.7202C6.92727 12.0131 6.92727 12.4879 7.22016 12.7808C7.51305 13.0737 7.98793 13.0737 8.28082 12.7808L12.7808 8.28082Z" fill="#3C67FF"/>
                  <path d="M9.00049 8.00049C9.00049 8.55277 8.55277 9.00049 8.00049 9.00049C7.4482 9.00049 7.00049 8.55277 7.00049 8.00049C7.00049 7.4482 7.4482 7.00049 8.00049 7.00049C8.55277 7.00049 9.00049 7.4482 9.00049 8.00049Z" fill="#3C67FF"/>
                  <path d="M12.0005 13.0005C12.5528 13.0005 13.0005 12.5528 13.0005 12.0005C13.0005 11.4482 12.5528 11.0005 12.0005 11.0005C11.4482 11.0005 11.0005 11.4482 11.0005 12.0005C11.0005 12.5528 11.4482 13.0005 12.0005 13.0005Z" fill="#3C67FF"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0948 3.51489C11.2728 1.7242 8.72823 1.7242 7.90617 3.51489C7.7306 3.89733 7.28997 4.07984 6.8954 3.93357C5.0479 3.24865 3.24865 5.0479 3.93357 6.8954C4.07984 7.28997 3.89733 7.7306 3.51489 7.90617C1.7242 8.72823 1.7242 11.2728 3.51489 12.0948C3.89733 12.2704 4.07984 12.711 3.93357 13.1056C3.24865 14.9531 5.0479 16.7523 6.8954 16.0674C7.28997 15.9212 7.7306 16.1037 7.90617 16.4861C8.72823 18.2768 11.2728 18.2768 12.0948 16.4861C12.2704 16.1037 12.711 15.9212 13.1056 16.0674C14.9531 16.7523 16.7523 14.9531 16.0674 13.1056C15.9212 12.711 16.1037 12.2704 16.4861 12.0948C18.2768 11.2728 18.2768 8.72823 16.4861 7.90617C16.1037 7.7306 15.9212 7.28997 16.0674 6.8954C16.7523 5.0479 14.9531 3.24865 13.1056 3.93357C12.711 4.07984 12.2704 3.89733 12.0948 3.51489ZM9.26938 4.14072C9.55636 3.51559 10.4446 3.51559 10.7316 4.14072C11.2345 5.23622 12.4968 5.75904 13.627 5.34003C14.272 5.10092 14.9001 5.72903 14.661 6.37399C14.242 7.50424 14.7648 8.76646 15.8603 9.26938C16.4854 9.55636 16.4854 10.4446 15.8603 10.7316C14.7648 11.2345 14.242 12.4968 14.661 13.627C14.9001 14.272 14.272 14.9001 13.627 14.661C12.4968 14.242 11.2345 14.7648 10.7316 15.8603C10.4446 16.4854 9.55636 16.4854 9.26938 15.8603C8.76646 14.7648 7.50424 14.242 6.37399 14.661C5.72903 14.9001 5.10092 14.272 5.34003 13.627C5.75904 12.4968 5.23622 11.2345 4.14072 10.7316C3.51559 10.4446 3.51559 9.55636 4.14072 9.26938C5.23622 8.76646 5.75904 7.50424 5.34003 6.37399C5.10092 5.72903 5.72903 5.10092 6.37399 5.34003C7.50424 5.75904 8.76646 5.23622 9.26938 4.14072Z" fill="#3C67FF"/>
                </svg>
                <span class="gf_pricing__discount--text">
                  Redeem discount code
                </span>
              </div>
            </template>
            <div class="gf_pricing__discount-popup">
              <div class="gf_pricing__discount-popup--header">
                <span>Redeem code</span>
                <svg @click="onCloseDiscountCode" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19.1765 20.0241C19.4108 20.2584 19.7907 20.2584 20.025 20.0241C20.2594 19.7898 20.2594 19.4099 20.025 19.1755L16.8493 15.9998L20.025 12.8241C20.2594 12.5898 20.2594 12.2099 20.025 11.9755C19.7907 11.7412 19.4108 11.7412 19.1765 11.9755L16.0008 15.1513L12.825 11.9755C12.5907 11.7412 12.2108 11.7412 11.9765 11.9755C11.7422 12.2099 11.7422 12.5898 11.9765 12.8241L15.1523 15.9998L11.9765 19.1755C11.7422 19.4099 11.7422 19.7898 11.9765 20.0241C12.2108 20.2584 12.5907 20.2584 12.825 20.0241L16.0008 16.8483L19.1765 20.0241Z" fill="#212121"/>
                </svg>
              </div>
              <div class="gf_pricing__discount-popup--form">
                <input type="text" :class="['input-code', {error: !discountMsg.success && discountMsg.message}]" v-model.trim="discountCode" placeholder="Enter discount code">
                <button :class="['btn btn-aply', {'enable': discountCode && !appliedCode}]" @click="onApplyCode">
                  <svg v-if="isLoading" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 1.25C10.3452 1.25 10.625 1.52982 10.625 1.875V5C10.625 5.34518 10.3452 5.625 10 5.625C9.65482 5.625 9.375 5.34518 9.375 5V1.875C9.375 1.52982 9.65482 1.25 10 1.25Z" fill="#F9F9F9"/>
                    <path d="M3.81294 3.8127C4.05702 3.56862 4.45275 3.56862 4.69682 3.8127L6.90653 6.02241C7.15061 6.26648 7.15061 6.66221 6.90653 6.90629C6.66246 7.15037 6.26673 7.15037 6.02265 6.90629L3.81294 4.69658C3.56886 4.4525 3.56886 4.05677 3.81294 3.8127Z" fill="#F9F9F9"/>
                    <path d="M1.875 9.375C1.52982 9.375 1.25 9.65482 1.25 10C1.25 10.3452 1.52982 10.625 1.875 10.625H5C5.34518 10.625 5.625 10.3452 5.625 10C5.625 9.65482 5.34518 9.375 5 9.375H1.875Z" fill="#F9F9F9"/>
                    <path d="M15 9.375C14.6548 9.375 14.375 9.65482 14.375 10C14.375 10.3452 14.6548 10.625 15 10.625H18.125C18.4702 10.625 18.75 10.3452 18.75 10C18.75 9.65482 18.4702 9.375 18.125 9.375H15Z" fill="#F9F9F9"/>
                    <path d="M13.9776 13.0935C13.7335 12.8494 13.3378 12.8494 13.0937 13.0935C12.8496 13.3376 12.8496 13.7333 13.0937 13.9774L15.3034 16.1871C15.5475 16.4311 15.9432 16.4311 16.1873 16.1871C16.4314 15.943 16.4314 15.5473 16.1873 15.3032L13.9776 13.0935Z" fill="#F9F9F9"/>
                    <path d="M10.625 15C10.625 14.6548 10.3452 14.375 10 14.375C9.65482 14.375 9.375 14.6548 9.375 15V18.125C9.375 18.4702 9.65482 18.75 10 18.75C10.3452 18.75 10.625 18.4702 10.625 18.125V15Z" fill="#F9F9F9"/>
                    <path d="M16.1871 3.8127C16.4311 4.05677 16.4311 4.4525 16.1871 4.69658L13.9773 6.90629C13.7333 7.15037 13.3375 7.15037 13.0935 6.90629C12.8494 6.66221 12.8494 6.26648 13.0935 6.02241L15.3032 3.8127C15.5473 3.56862 15.943 3.56862 16.1871 3.8127Z" fill="#F9F9F9"/>
                    <path d="M6.90628 13.9774C7.15036 13.7333 7.15036 13.3376 6.90628 13.0935C6.6622 12.8494 6.26648 12.8494 6.0224 13.0935L3.81269 15.3032C3.56861 15.5473 3.56861 15.943 3.81269 16.1871C4.05677 16.4311 4.4525 16.4311 4.69657 16.1871L6.90628 13.9774Z" fill="#F9F9F9"/>
                  </svg>
                  <span v-else>Apply</span>
                </button>
              </div>
              <div class="gf_pricing__discount-popup--message" v-if="discountMsg.message">
                <svg v-if="discountMsg.success" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 1.25C5.125 1.25 1.25 5.125 1.25 10C1.25 14.875 5.125 18.75 10 18.75C14.875 18.75 18.75 14.875 18.75 10C18.75 5.125 14.875 1.25 10 1.25ZM8 14L4.75 10.75L5.625 9.875L8 12.25L14.375 6L15.25 6.875L8 14Z" fill="#00A042"/>
                </svg>
                <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10.0232 4.97143C10.3388 4.97143 10.5946 5.22727 10.5946 5.54286V11.2571C10.5946 11.5727 10.3388 11.8286 10.0232 11.8286C9.70762 11.8286 9.45179 11.5727 9.45179 11.2571V5.54286C9.45179 5.22727 9.70762 4.97143 10.0232 4.97143ZM10 12.7429C9.49505 12.7429 9.08571 13.1522 9.08571 13.6571C9.08571 14.1621 9.49505 14.5714 10 14.5714C10.5049 14.5714 10.9143 14.1621 10.9143 13.6571C10.9143 13.1522 10.5049 12.7429 10 12.7429Z" fill="#C3362B"/>
                </svg>
                <span :class="discountMsg.class" v-html="discountMsg.message"></span>
              </div>
            </div>
          </Dropdown>
        </div>
        <Item
          v-for="(content, key) in dynamicContent.plans"
          :content="content"
          :key="key"
          :yearly-mode="isYearly"
          :isRecommended="recommended === key"
          :planNo="key" />
      </div>
    </div>
    <div class="gf_compare__plan gf_pricing__container" v-if="isShowTablePricing">
      <template v-for="(group, groupIndex) in dataPlan.compare">
        <div class="gf_plan__group" :key="groupIndex">
          <div class="gf_plan__group-text">
            {{ $t(group.title) }}
          </div>
          <template v-for="(option, optionIndex) in group.options">
            <div v-if="isDisplayOptionsByConditions(option.display_conditions)" class="gf_plan__option" :key="optionIndex">
              <div class="gf_price-compare__section gf_pricing__container" :class="{'gf_price-compare__section--trial': isTableCol4}">
                <div class="gf_price-compare__box__plan gf_plan__option__item gf_plan__option--title" :class="{'gf_price-compare__box__plan--trial': isTableCol4}">
                  {{ $t(option.title) }} <BetaTag v-if="option.isBeta" /> <NewTag v-if="option.isNew" />
                  <div class="gf_price-intro__item--tooltip" v-if="option.tooltip">
                    <PricingTooltips
                      type="default"
                      :isBeta="option.isBeta"
                      :image="option.tooltip.image"
                      :title="option.tooltip.title"
                      :description="option.tooltip.desc" />
                  </div>
                  </div>
                <div class="gf_price-compare__box__plan gf_plan__option__item gf_plan__option--status" :class="{'gf_price-compare__box__plan--trial': isTableCol4, 'gf_plan__option__item__desc': option.trial.desc}" v-if="option.trial && isFreeTrial">
                    <template v-if="option.trial.title">
                      <span v-html="$t(option.trial.title)"></span>
                    </template>
                    <template v-else>
                      <img v-if="option.trial.status" src="../../assets/status-check.svg">
                      <img v-else src="../../assets/status-false.svg">
                    </template>
                    <template v-if="option.trial.desc" >
                      <div class="gf_plan__option__item__desc-list">
                        <div class="gf_plan__option__item__desc-item" v-for="(item, index) in option.trial.desc" :key="index">
                          <img v-if="item.status" src="../../assets/status-check.svg">
                          <img v-else src="../../assets/status-false.svg">
                          <span v-html="$t(item.title)"></span>
                          <UpcomingTag v-if="item.isUpcoming" />
                        </div>
                      </div>
                    </template>
                </div>
                <div class="gf_price-compare__box__plan gf_plan__option__item gf_plan__option--status" :class="{'gf_price-compare__box__plan--trial': isTableCol4, 'gf_plan__option__item__desc': option.trial2022.desc}" v-if="option.trial2022 && isFreeTrial2022">
                    <template v-if="option.trial2022.title">
                      <span v-html="$t(option.trial2022.title)"></span>
                    </template>
                    <template v-else>
                      <img v-if="option.trial2022.status" src="../../assets/status-check.svg">
                      <img v-else src="../../assets/status-false.svg">
                    </template>
                    <template v-if="option.trial2022.desc" >
                      <div class="gf_plan__option__item__desc-list">
                        <div class="gf_plan__option__item__desc-item" v-for="(item, index) in option.trial2022.desc" :key="index">
                          <img v-if="item.status" src="../../assets/status-check.svg">
                          <img v-else src="../../assets/status-false.svg">
                          <span v-html="$t(item.title)"></span>
                          <UpcomingTag v-if="item.isUpcoming" />
                        </div>
                      </div>
                    </template>
                </div>
                <div class="gf_price-compare__box__plan gf_plan__option__item gf_plan__option--status" :class="{'gf_price-compare__box__plan--trial': isTableCol4, 'gf_plan__option__item__desc': option.development.desc}" v-if="option.development && isDevelopment">
                    <template v-if="option.development.title">
                      <span v-html="$t(option.development.title)"></span>
                    </template>
                    <template v-else>
                      <img v-if="option.development.status" src="../../assets/status-check.svg">
                      <img v-else src="../../assets/status-false.svg">
                    </template>
                    <template v-if="option.development.desc" >
                      <div class="gf_plan__option__item__desc-list">
                        <div class="gf_plan__option__item__desc-item" v-for="(item, index) in option.development.desc" :key="index">
                          <img v-if="item.status" src="../../assets/status-check.svg">
                          <img v-else src="../../assets/status-false.svg">
                          <span v-html="$t(item.title)"></span>
                          <UpcomingTag v-if="item.isUpcoming" />
                        </div>
                      </div>
                    </template>
                </div>
                <div class="gf_price-compare__box__plan gf_plan__option__item gf_plan__option--status" :class="{'gf_price-compare__box__plan--trial': isTableCol4, 'gf_plan__option__item__desc': option.development2022.desc}" v-else-if="option.development2022 && (isDevelopment2022 || isDevelopment)">
                  <template v-if="option.development2022.yearly && yearlyMode && !isDevelopment">
                    <template v-if="option.development2022.yearly.title">
                      <span v-html="$t(option.development2022.title)"></span>
                    </template>
                    <template v-else>
                      <img v-if="option.development2022.yearly.status" src="../../assets/status-check.svg">
                      <img v-else src="../../assets/status-false.svg">
                    </template>
                  </template>
                  <template v-else-if="option.development2022.title">
                    <span v-html="$t(option.development2022.title)"></span>
                  </template>
                  <template v-else>
                    <img v-if="option.development2022.status" src="../../assets/status-check.svg">
                    <img v-else src="../../assets/status-false.svg">
                  </template>
                  <template v-if="option.development2022.desc" >
                    <div class="gf_plan__option__item__desc-list">
                      <div class="gf_plan__option__item__desc-item" v-for="(item, index) in option.development2022.desc" :key="index">
                        <img v-if="item.status" src="../../assets/status-check.svg">
                        <img v-else src="../../assets/status-false.svg">
                        <span v-html="$t(item.title)"></span>
                        <UpcomingTag v-if="item.isUpcoming" />
                      </div>
                    </div>
                  </template>
                </div>
                <div class="gf_price-compare__box__plan gf_plan__option__item gf_plan__option--status" :class="{'gf_price-compare__box__plan--trial': isTableCol4, 'gf_plan__option__item__desc': option.starter.desc}" v-if="option.starter && isStarter">
                    <template v-if="option.starter.title">
                      <span v-html="$t(option.starter.title)"></span>
                    </template>
                    <template v-else>
                      <img v-if="option.starter.status" src="../../assets/status-check.svg">
                      <img v-else src="../../assets/status-false.svg">
                    </template>
                    <template v-if="option.starter.desc" >
                      <div class="gf_plan__option__item__desc-list">
                        <div class="gf_plan__option__item__desc-item" v-for="(item, index) in option.starter.desc" :key="index">
                          <img v-if="item.status" src="../../assets/status-check.svg">
                          <img v-else src="../../assets/status-false.svg">
                          <span v-html="$t(item.title)"></span>
                          <UpcomingTag v-if="item.isUpcoming" />
                        </div>
                      </div>
                    </template>
                </div>
                <div class="gf_price-compare__box__plan gf_plan__option__item gf_plan__option--status" :class="{'gf_price-compare__box__plan--trial': isTableCol4, 'gf_plan__option__item__desc': option.professional.desc}" v-if="option.professional && currentPlanProfessional && !isDevelopment">
                  <template v-if="option.professional.yearly && yearlyMode">
                    <template v-if="option.professional.yearly.title">
                      <span v-html="$t(option.professional.title)"></span>
                    </template>
                    <template v-else>
                      <img v-if="option.professional.yearly.status" src="../../assets/status-check.svg">
                      <img v-else src="../../assets/status-false.svg">
                    </template>
                  </template>  
                  <template v-else-if="option.professional.title">
                    <span v-html="$t(option.professional.title)"></span>
                  </template>
                  <template v-else>
                    <img v-if="option.professional.status" src="../../assets/status-check.svg">
                    <img v-else src="../../assets/status-false.svg">
                  </template>
                  <template v-if="option.professional.desc" >
                    <div class="gf_plan__option__item__desc-list">
                      <div class="gf_plan__option__item__desc-item" v-for="(item, index) in option.professional.desc" :key="index">
                        <img v-if="item.status" src="../../assets/status-check.svg">
                        <img v-else src="../../assets/status-false.svg">
                        <span v-html="$t(item.title)"></span>
                        <UpcomingTag v-if="item.isUpcoming" />
                      </div>
                    </div>
                  </template>
                </div>
                <div class="gf_price-compare__box__plan gf_plan__option__item gf_plan__option--status" :class="{'gf_price-compare__box__plan--trial': isTableCol4, 'gf_plan__option__item__desc': option.build.desc}" v-else-if="option.build">
                  <template v-if="option.build.yearly && yearlyMode && !currentPlanProfessional">
                    <template v-if="option.build.yearly.title">
                      <span v-html="$t(option.build.title)"></span>
                    </template>
                    <template v-else>
                      <img v-if="option.build.yearly.status" src="../../assets/status-check.svg">
                      <img v-else src="../../assets/status-false.svg">
                    </template>
                  </template>
                  <template v-else-if="option.build.title">
                    <span v-html="$t(option.build.title)"></span>
                  </template>
                  <template v-else>
                    <img v-if="option.build.status" src="../../assets/status-check.svg">
                    <img v-else src="../../assets/status-false.svg">
                  </template>
                  <template v-if="option.build.desc" >
                    <div class="gf_plan__option__item__desc-list">
                      <div class="gf_plan__option__item__desc-item" v-for="(item, index) in option.build.desc" :key="index">
                        <img v-if="item.status" src="../../assets/status-check.svg">
                        <img v-else src="../../assets/status-false.svg">
                        <span v-html="$t(item.title)"></span>
                        <UpcomingTag v-if="item.isUpcoming" />
                      </div>
                    </div>
                  </template>
                </div>
                <div class="gf_price-compare__box__plan gf_plan__option__item gf_plan__option--status" :class="{'gf_price-compare__box__plan--trial': isTableCol4, 'gf_plan__option__item__desc': option.optimize.desc}" v-if="option.optimize">
                  <template v-if="(option.optimize.planOld && isAdvancePlan)">
                    <template v-if="option.optimize.planOld.title">
                      <span v-html="$t(option.optimize.planOld.title)"></span>
                    </template>
                    <template v-else>
                      <img v-if="option.optimize.planOld.status" src="../../assets/status-check.svg">
                      <img v-else src="../../assets/status-false.svg">
                    </template>
                  </template>   
                  <template v-else-if="(option.optimize.yearly && yearlyMode)">
                    <template v-if="option.optimize.yearly.title">
                      <span v-html="$t(option.optimize.title)"></span>
                    </template>
                    <template v-else>
                      <img v-if="option.optimize.yearly.status" src="../../assets/status-check.svg">
                      <img v-else src="../../assets/status-false.svg">
                    </template>
                  </template>   
                  <template v-else-if="option.optimize.title">
                    <span v-html="$t(option.optimize.title)"></span>
                  </template>
                  <template v-else>
                    <img v-if="option.optimize.status" src="../../assets/status-check.svg">
                    <img v-else src="../../assets/status-false.svg">
                  </template>
                  <template v-if="option.optimize.desc" >
                    <div class="gf_plan__option__item__desc-list">
                      <div class="gf_plan__option__item__desc-item" v-for="(item, index) in option.optimize.desc" :key="index">
                        <img v-if="item.status" src="../../assets/status-check.svg">
                        <img v-else src="../../assets/status-false.svg">
                        <span v-html="$t(item.title)"></span>
                        <UpcomingTag v-if="item.isUpcoming" />
                      </div>
                    </div>
                  </template>
                </div>
                <div class="gf_price-compare__box__plan gf_plan__option__item gf_plan__option--status" :class="{'gf_price-compare__box__plan--trial': isTableCol4}" v-if="option.enterprise">
                  <template v-if="option.enterprise.yearly && yearlyMode">
                    <template v-if="option.enterprise.yearly.title">
                      <span v-html="$t(option.enterprise.title)"></span>
                    </template>
                    <template v-else>
                      <img v-if="option.enterprise.yearly.status" src="../../assets/status-check.svg">
                      <img v-else src="../../assets/status-false.svg">
                    </template>
                  </template>    
                  <template v-else-if="option.enterprise.title">
                    <span v-html="$t(option.enterprise.title)"></span>
                  </template>
                  <template v-else>
                    <img v-if="option.enterprise.status" src="../../assets/status-check.svg">
                    <img v-else src="../../assets/status-false.svg">
                  </template>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Switcher from "@/core/shared/essenstials/Switcher.vue";
import Item from "@/modules/Pricing/components/PricingPlanCompare/Item";
import plan from "@/modules/Pricing/mixins/plan";
import PricingTooltips from "@/modules/Pricing/components/PricingTooltips";
import { PLAN_NO, PLAN_TYPE } from "@/contants/plan";
import BetaTag from "./BetaTag.vue"
import NewTag from "./NewTag.vue"
import UpcomingTag from "./UpcomingTag.vue";
import { mapActions } from "vuex"
import promotion from "../../mixins/promotion";

export default {
  name: "TablePricing",
  components: {
    Switcher,
    Item,
    PricingTooltips,
    BetaTag,
    NewTag,
    UpcomingTag
},
  mixins: [plan(), promotion()],
  props: {
    dataPlan: {
      type: Object || Array,
      default: () => [],
    },
    currentPlan: {
      type: String,
    },
    isShowTablePricing: {
      default: false,
    },
  },
  data() {
    return {
      isFixedNav: false,
      yearlyMode: false,
      discountCode: '',
      discountMsg: {},
      isLoading: false,
      appliedCode: false,
    }
  },
  computed: {
    isAdvancePlan() {
      return this.plan === PLAN_NO.ADVANCED;
    },
    appliedCoupon () {
      return this.paymentInfo.plans.find((plan) => plan.planType === this.yearlyMode ? PLAN_TYPE.ANNUALLY : PLAN_TYPE.MONTHLY && plan.planName === PLAN_NO.BUILD).appliedCoupon;
    }
  },
  watch: {
    yearlyMode(value) {
      this.$eventBus.$emit('switch-yearly-mode-compare', value);
    },
    discountCode () {
      this.appliedCode = false;
      this.discountMsg = {};
    }
  },
  mounted() {
    this.handleScroll();
    this.$eventBus.$off('switch-yearly-mode')
    this.$eventBus.$on('switch-yearly-mode', (mode) => {
      this.yearlyMode = mode
    });
  },
  methods: {
    ...mapActions("dashboard", {
      getCoupon: "getCoupon",
      fetchPaymentInfo: "fetchPaymentInfo"
    }),
    handleScroll() {
      const body = document.getElementById("gfPricing");
      if (body) {
        body.onscroll = () => {
          const elementOffset = document.getElementById("gfPricingTable").offsetTop;
          const scrollY = body.scrollTop;
          if (scrollY > (elementOffset - 150)) {
            this.$nextTick(() => {
              this.isFixedNav = true;
            })
          } else {
            this.$nextTick(() => {
              this.isFixedNav = false;
            })
          }
        };
      }
    },
    isDisplayOptionsByConditions(conditions){
      if(!conditions){
        return true;
      }
      const {gem_versions} = conditions;
      return gem_versions.includes(this.gemVersion);
    },
    onCloseDiscountCode () {
      this.$refs.discountCode.closeDropdown();
      this.discountMsg = {};
      this.discountCode = '';
      this.appliedCode = false;
    },
    async onApplyCode () {
      if (this.isLoading || !this.discountCode || this.appliedCode) return;
      this.isLoading = true;
      if (this.appliedCoupon?.code == this.discountCode) {
        this.discountMsg = {
          success: false,
          message: 'Code is already in use',
          class: 'error'
        }
        this.appliedCode = true;
        this.isLoading = false;
        return;
      }
      const res = await this.getCoupon(this.discountCode)
      if (res.success) {
        this.discountMsg = {
          success: true,
          message: 'Code applied successfully',
          class: 'success'
        }
        this.yearlyMode = false;
        this.setYearlyMode(false);
        this.fetchPaymentInfo();
      } else {
        this.discountMsg = {
          success: false,
          message: res.message,
          class: 'error'
        }
      }
      this.appliedCode = true;
      this.isLoading = false;
    }
  },
};
</script>

<style lang="scss" scoped>
  @import "./style.scss";
  .gf_pricing__discount {
    display: flex;
    align-items: center;
    margin-top: 8px;
    cursor: pointer;

    &--text {
      color: #3C67FF;
      font-size: 14px;
      line-height: 24px;
      font-weight: 500;
      padding-left: 4px;
    }

    &-popup {
      box-shadow: 0px 8px 45px 2px #00000014;
      padding: 16px;
      width: 312px;
      border-radius: 12px;

      &--header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;

        span {
          color: #212121;
          font-size: 14px;
          line-height: 24px;
          font-weight: 600;
        }
        svg {
          cursor: pointer;
          margin-top: -6px;
          margin-right: -6px;

          &:hover {
            background: #F6F6F6;
            border-radius: 8px;
          }
        }
      }

      &--form {
        display: flex;
        align-items: center;

        .input-code {
          background: #F4F4F4;
          border-radius: 8px;
          height: 36px;
          width: 100%;
          max-width: 100%;
        }

        .error {
          border: 1px solid #F44336;
        }

        .btn-aply {
          background: #F4F4F4;
          padding: 6px 16px 6px 16px;
          color: #9E9E9E;
          font-size: 14px;
          line-height: 24px;
          font-weight: 500;
          border-radius: 8px;
          margin-left: 8px;
          width: 71px;
          cursor: not-allowed;
        }

        .enable {
          background: #3C67FF;
          color: #F9F9F9;
          cursor: pointer;
        }
      }

      &--message {
        display: flex;
        align-items: flex-start;
        margin-top: 8px;

        .success, .error {
          margin-left: 8px;
          font-size: 12px;
          line-height: 20px;
          font-weight: 450;
          max-width: calc(100% - 28px);
        }

        .success {
          color: #00A042;
        }
        .error {
          color: #C3362B;
        }
      }
    }
  }
</style>
